import CustomBase from './CustomBase';
import { backend } from '../../setup';

class CustomSequenceModel extends CustomBase {

	constructor( json:Object ){
		super( json );	
	}
	
	get description():string {
		return this.get<string>( 'description' );	
	}
	
	set description( t:string ){
		this.set( 'description', t );	
	}
}

export default CustomSequenceModel;

backend.mapper.toModel.add( 'App\\CustomSequence', function( json:any ){
	return new CustomSequenceModel( json );
});

backend.mapper.toJson.add( 'App\\CustomSequence', function( model:CustomSequenceModel ) {
	return model.object();
});